import { StackProps, Text, VStack } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { SectionTitle } from '../atoms/Title.tsx';

export function Labeled({
  label,
  helpText,
  footerText,
  children,
  labelSize = '18px',
  labelColor,
  ...props
}: {
  label: string;
  labelSize?: string | number;
  helpText?: string;
  footerText?: string;
  labelColor?: string;
} & PropsWithChildren &
  StackProps) {
  return (
    <VStack width={'100%'} align={'flex-start'} {...props}>
      <SectionTitle color={labelColor} fontSize={labelSize}>
        {label}
      </SectionTitle>
      {helpText && (
        <Text marginTop={'-5px'} fontSize={'14px'} color={'#a9a9a9'}>
          {helpText}
        </Text>
      )}
      {children}
      {footerText && (
        <Text marginTop={'-5px'} fontSize={'14px'} color={'#a9a9a9'}>
          {footerText}
        </Text>
      )}
    </VStack>
  );
}
